/**
 * Created by B032151 on 12/16/2016.
 */
import Constants from "../constants/constants";
import { subdivisionStore } from "../stores/subdivision";
import { formValidation } from "../util/formValidation";
var regex = Constants.Regex;
var userIdRegex = new RegExp(regex.userIdRegex);
var mpRegex = new RegExp(regex.mpRegex);

function validateAdminInputRow(itemType, row, buttonClicked) {
  var overrideUserValidity = { canSubmit: false };
  switch (itemType) {
    case "/override":
      overrideUserValidity = checkOverrideUserValidity(row, buttonClicked);
      break;
    default:
      break;
  }

  return overrideUserValidity;
}

function checkOverrideUserValidity(overrideUser, buttonClicked) {
  var subData = subdivisionStore.getSubData();
  var overrideUserValidity = {
    userIdValidity: null,
    userIdHelpMessage: null,
    subdivisionValidity: null,
    subdivisionHelpMessage: null,
    startMpValidity: null,
    startMpHelpMessage: null,
    endMpValidity: null,
    endMpHelpMessage: null,
    minuteLimitValidity: null,
    minuteLimitHelpMessage: null,
    numberRequestedValidity: null,
    numberRequestedHelpMessage: null,
    reasonCodeValidity: null,
    reasonCodeHelpMessage: null,
    canSubmit: true,
  };

  //UserId validation test
  if (!overrideUser.userId) {
    if (buttonClicked) {
      overrideUserValidity.userIdValidity = "error";
      overrideUserValidity.userIdHelpMessage = "User Id is required";
      overrideUserValidity.canSubmit = false;
    }
  } else {
    if (!userIdRegex.test(overrideUser.userId)) {
      overrideUserValidity.userIdValidity = "error";
      overrideUserValidity.userIdHelpMessage = "Invalid id";
      overrideUserValidity.canSubmit = false;
    }
  }

  //Subdivision validation test
  if (buttonClicked && !overrideUser.subdivision) {
    overrideUserValidity.subdivisionValidity = "error";
    overrideUserValidity.subdivisionHelpMessage = "Subdivision is required";
    overrideUserValidity.canSubmit = false;
  }

  //Start Mp validation test
  if (!overrideUser.startMp) {
    if (buttonClicked) {
      overrideUserValidity.startMpValidity = "error";
      overrideUserValidity.startMpHelpMessage = "Start Mp is required";
      overrideUserValidity.canSubmit = false;
    }
  } else {
    if (!mpRegex.test(overrideUser.startMp)) {
      overrideUserValidity.startMpValidity = "error";
      overrideUserValidity.startMpHelpMessage = "Must be in format 9999.99";
      overrideUserValidity.canSubmit = false;
    } else {
      if (
        subData != null &&
        !formValidation.mpInRange(
          overrideUser.startMp,
          overrideUser.startMpSuffix,
          subData.milePostRangeList
        )
      ) {
        overrideUserValidity.startMpValidity = "error";
        overrideUserValidity.startMpHelpMessage =
          "Not valid for " + overrideUser.subdivision;
        overrideUserValidity.canSubmit = false;
      }
    }
  }

  //End Mp validation test
  if (!overrideUser.endMp) {
    if (buttonClicked) {
      overrideUserValidity.endMpValidity = "error";
      overrideUserValidity.endMpHelpMessage = "End Mp is required";
      overrideUserValidity.canSubmit = false;
    }
  } else {
    if (!mpRegex.test(overrideUser.endMp)) {
      overrideUserValidity.endMpValidity = "error";
      overrideUserValidity.endMpHelpMessage = "Must be in format 9999.99";
      overrideUserValidity.canSubmit = false;
    } else {
      if (
        subData != null &&
        !formValidation.mpInRange(
          overrideUser.endMp,
          overrideUser.endMpSuffix,
          subData.milePostRangeList
        )
      ) {
        overrideUserValidity.endMpValidity = "error";
        overrideUserValidity.endMpHelpMessage =
          "Not valid for " + overrideUser.subdivision;
        overrideUserValidity.canSubmit = false;
      }
    }
  }

  //Minute Limit Validation test
  if (!overrideUser.minuteLimit) {
    if (buttonClicked) {
      overrideUserValidity.minuteLimitValidity = "error";
      overrideUserValidity.minuteLimitHelpMessage = "Minutes are required";
      overrideUserValidity.canSubmit = false;
    }
  } else {
    var mins = parseInt(overrideUser.minuteLimit);

    if (isNaN(mins)) {
      overrideUserValidity.minuteLimitValidity = "error";
      overrideUserValidity.minuteLimitHelpMessage = "Minutes must be a number";
      overrideUserValidity.canSubmit = false;
    } else {
      if (mins < 0 || mins > 30) {
        overrideUserValidity.minuteLimitValidity = "error";
        overrideUserValidity.minuteLimitHelpMessage =
          "Minutes must be between 1 and 30";
        overrideUserValidity.canSubmit = false;
      }
    }
  }
  return overrideUserValidity;
}

export { validateAdminInputRow, checkOverrideUserValidity };
